import { Controller } from "@hotwired/stimulus"

// Modal for the new (Tailwind) UI — replaces the Bootstrap Modal used by
// modal_controller.js. Attach to the modal root (the full-screen backdrop element).
// It shows on connect and closes on Escape, a click on the backdrop itself, any
// [data-action="tw-modal#close"] control, or a successful Turbo form submit.
//
//   <div data-controller="tw-modal" data-action="click->tw-modal#backdrop"
//        class="fixed inset-0 z-50 grid place-items-center bg-black/40">
//     <div class="bg-white rounded-2xl …"> … <button data-action="tw-modal#close">×</button> </div>
//   </div>
export default class extends Controller {
  connect() {
    this.onKey = this.onKey.bind(this)
    this.onSubmitEnd = this.onSubmitEnd.bind(this)
    this.onClick = this.onClick.bind(this)
    document.addEventListener("keydown", this.onKey)
    this.element.addEventListener("turbo:submit-end", this.onSubmitEnd)
    // Reused (unconverted) form partials close via Bootstrap's data-bs-dismiss="modal".
    // Honor those clicks so their Cancel/Close buttons work inside this Tailwind dialog.
    this.element.addEventListener("click", this.onClick)
    document.body.classList.add("overflow-hidden")
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
    this.element.removeEventListener("turbo:submit-end", this.onSubmitEnd)
    this.element.removeEventListener("click", this.onClick)
    document.body.classList.remove("overflow-hidden")
  }

  onClick(event) {
    if (event.target.closest('[data-bs-dismiss="modal"]')) {
      event.preventDefault()
      this.close()
    }
  }

  close(event) {
    if (event) event.preventDefault()
    if (this.closing) return
    this.closing = true
    // play the reverse animation (see tailwind.input.css), then remove; the timeout is a
    // safety net for prefers-reduced-motion, where no animation (or animationend) fires
    this.element.classList.add("tw-modal-closing")
    const remove = () => this.element.remove()
    this.element.addEventListener("animationend", remove, { once: true })
    setTimeout(remove, 200)
  }

  // Close only when the backdrop itself is clicked, not the dialog inside it.
  backdrop(event) {
    if (event.target === this.element) this.close()
  }

  onSubmitEnd(event) {
    if (event.detail.success) this.close()
  }

  onKey(event) {
    if (event.key === "Escape") this.close()
  }
}
